import { OnInit } from '@angular/core';
var DnDItemComponent = /** @class */ (function () {
    function DnDItemComponent() {
    }
    DnDItemComponent.prototype.ngOnInit = function () {
    };
    return DnDItemComponent;
}());
export { DnDItemComponent };
